import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Screen from '../../components/common/Screen';
import Card from '../../components/elements/Card';
import './Supplier.css';

/* Where a link from an operations-request mail lands when it no longer opens anything: the
   event is over, the request was withdrawn or now names somebody else, or the link was mangled.
   No login wall — the person was never asked for a password and should not meet one here. */
const SupplierClosed = () => {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const reason = params.get('reason') || 'invalid';
  const key = { closed: 'opsLinkClosed', gone: 'opsLinkGone', not_contact: 'opsLinkNotYou' }[reason] || 'opsLinkInvalid';
  return (
    <Screen>
      <div className="top">
        <Card>
          <h3 className="ops-card-title">{t('opsLinkTitle')}</h3>
          <p className="ops-hint">{t(key)}</p>
        </Card>
      </div>
    </Screen>
  );
};

export default SupplierClosed;
